// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#plans_no_discount[data-v-6b1df4aa]{position:relative;width:-moz-fit-content;width:fit-content}#plans_no_discount[data-v-6b1df4aa]:after{background-color:#a5a6a4;content:\"\";height:2px;left:0;position:absolute;top:50%;width:95%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
